export enum Page {
  DASHBOARD = 'dashboard',
  INSTALLATION = 'installation',
  CUSTOMER_PORTAL = 'customerPortal',
  ACCOUNT = 'account',
}
